import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import FormRepeater from "../form/FormRepeater";
import SpecialtyItemRow from "./SpecialtyItemRow";

// The catalog lines on a sell order, as an editable table on Create and as a
// read-only recap on the payment step. DH-2628 reuses it read-only for order
// details, which is why the catalog is a prop: a recap of already-sold lines
// carries its own snapshot and needs no catalog at all.
const SpecialtyItemsSection = ({
  lines = [],
  onChange = () => {},
  catalog = [],
  taxRate = 0,
  readOnly = false,
  loading = false,
  hideTitle = false,
}) => {
  const { t } = useTranslation();
  const memoizedRowData = useMemo(() => lines, [lines]);

  const columns = [
    t("Item"),
    t("Amount"),
    t("Quantity"),
    t("Line Total"),
    t("Tax"),
    ...(readOnly ? [] : [t("Action")]),
  ];

  return (
    <div className="mb-3">
      {!hideTitle && <>
        <h5 className="mb-0">{t("Specialty Items")}</h5>
        <hr className="size-3" />
      </>}
      <FormRepeater
        columns={columns}
        maxRows={20}
        addRowText={t("Add Specialty Item")}
        RenderComponent={SpecialtyItemRow}
        onRowChange={onChange}
        rowData={memoizedRowData}
        hideAddRow={readOnly}
        catalog={catalog}
        taxRate={taxRate}
        readOnly={readOnly}
        loading={loading}
      />
    </div>
  );
};

export default SpecialtyItemsSection;
